import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=81d132e0&scoped=true"
import script from "./ErrorDialog.vue?vue&type=script&lang=ts"
export * from "./ErrorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d132e0",
  null
  
)

export default component.exports